import { InputNumber } from 'antd';
import React from 'react';

const InputNumberComponent = (props) => {
  const handleChange = (value) => {
    if (typeof props.onChange === 'function') {
      props.onChange(value);
    }
  };

  return (
    <InputNumber
      maxLength={300}
      min={0}
      {...props}
      onChange={handleChange}
    />
  );
};

export default InputNumberComponent;